import React from 'react';
import { Button, Checkbox, Input, Modal } from 'antd';
import { CARD_REQUEST_COPY } from '../copy';
import { TCardRequestContext, buildCardRequestNote } from '../messageDrafts';
import { TAaaEntry } from '../aaa';
import s from '../s.module.less';

type TChannel = 'chat' | 'text' | 'email';

type Props = {
    open: boolean;
    payerName: string;
    // 修复卡入口带 AAA 上下文（决定预填 note 的措辞）；无码入口用 context 区分 inactive / 中性
    aaa?: TAaaEntry;
    context?: TCardRequestContext;
    planName?: string;
    persona: 'managed' | 'manual';
    sending: boolean;
    onCancel: () => void;
    onSend: (note: string, channels: TChannel[]) => void;
};

// Request updated insurance：预填 note（系统解释为什么要文件）+ 三渠道默认全开
const CardRequestModal: React.FC<Props> = ({
    open,
    payerName,
    aaa,
    context,
    planName,
    persona,
    sending,
    onCancel,
    onSend,
}) => {
    const [note, setNote] = React.useState('');
    const [channels, setChannels] = React.useState<TChannel[]>(['chat', 'text', 'email']);

    React.useEffect(() => {
        if (open) {
            setNote(buildCardRequestNote(payerName, aaa, context, planName));
            setChannels(['chat', 'text', 'email']);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            title={CARD_REQUEST_COPY.title}
            width={480}
            wrapClassName={s.eligModalScope}
            footer={
                <>
                    <Button onClick={onCancel}>{CARD_REQUEST_COPY.cancel}</Button>
                    <Button type="primary" loading={sending} onClick={() => onSend(note, channels)}>
                        {CARD_REQUEST_COPY.send}
                    </Button>
                </>
            }
        >
            <div className={s.cardReqLabel}>{CARD_REQUEST_COPY.noteLabel}</div>
            <Input.TextArea rows={6} value={note} onChange={(e) => setNote(e.target.value)} />
            <div className={s.cardReqHint}>{CARD_REQUEST_COPY.noteHint}</div>
            <div className={s.cardReqLabel}>{CARD_REQUEST_COPY.channelsLabel}</div>
            <div className={s.cardReqChannels}>
                {CARD_REQUEST_COPY.channels.map((c) => (
                    <Checkbox
                        key={c.key}
                        checked={channels.includes(c.key)}
                        onChange={(e) =>
                            setChannels((prev) =>
                                e.target.checked ? [...prev, c.key] : prev.filter((k) => k !== c.key),
                            )
                        }
                    >
                        {c.label}
                    </Checkbox>
                ))}
            </div>
            {/* 仅带 AAA 上下文的非 program：说明卡片到位后的自动 re-check 会计费 */}
            {aaa && persona === 'manual' && <div className={s.cardReqAuto}>{CARD_REQUEST_COPY.autoRecheckNote}</div>}
        </Modal>
    );
};

export default CardRequestModal;
